import React from 'react';

const Terms: React.FC = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '40px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ color: '#333', marginBottom: '30px' }}>Terms & Conditions</h1>
        
        <div style={{ lineHeight: '1.6', color: '#555' }}>
          <h2>8K Getter SMS Alert Service</h2>
          <p><strong>Effective Date:</strong> August 27, 2024</p>
          
          <h3>1. Service Description</h3>
          <p>8K Getter provides real-time SMS notifications for SEC filing alerts including 8-K, 10-K, 10-Q, DEF 14A, S-1, and Form 4 documents for publicly traded companies.</p>
          
          <h3>2. SMS Consent</h3>
          <p>By providing your phone number and completing verification, you consent to receive SMS alerts about SEC filings. Message frequency varies based on your selected tickers and filing activity. Standard SMS rates apply from your carrier.</p>
          
          <h3>3. Opt-Out Instructions</h3>
          <p>You may opt out at any time by:</p>
          <ul>
            <li>Replying "STOP" to unsubscribe from all alerts</li>
            <li>Replying "STOP [TICKER]" to unsubscribe from specific ticker alerts</li>
            <li>Visiting 8kgetter.com to manage your preferences</li>
          </ul>
          
          <h3>4. Data Usage</h3>
          <p>We collect and store your phone number and ticker preferences to provide the service. We do not sell or share your personal information with third parties for marketing purposes.</p>
          
          <h3>5. Service Availability</h3>
          <p>While we strive for 100% uptime, SMS delivery depends on carrier networks and SEC data availability. We are not liable for delayed or missed notifications.</p>
          
          <h3>6. Limitation of Liability</h3>
          <p>8K Getter provides informational alerts only. We are not responsible for investment decisions made based on our notifications. Always verify information directly with SEC filings.</p>
          
          <h3>7. Changes to Terms</h3>
          <p>We may update these terms at any time. Continued use of the service constitutes acceptance of updated terms.</p>
          
          <h3>8. Contact Information</h3>
          <p>For questions about these terms, contact us at jon@sum1solutions.com or +1 (401) 294-8255.</p>
          
          <p style={{ marginTop: '40px', fontSize: '14px', color: '#888' }}>
            © 2024 Sum1 Solutions, LLC. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
